import { render, staticRenderFns } from "./FlightItem.vue?vue&type=template&id=bac8829e"
import script from "./FlightItem.vue?vue&type=script&lang=js"
export * from "./FlightItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports